var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.info)?_c('div',[(_vm.showSpouse)?_c('Spouse',{attrs:{"info":_vm.data.spouse}}):_vm._e(),(_vm.data.children)?_c('Children',{attrs:{"info":_vm.data.children}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }